import { getEnv } from "business-layer/helpers/env";
const randomizer = (new Date()).getTime();

// const getApiPath = (domain: string) => ({
//   localizationUrl: `${domain}/payment/PayByLink/labels?${randomizer}`,
//   gatewayConfigUrl: `${domain}/payment/PayByLink/getBillingDetails?${randomizer}`,
//   dataUrl: `${domain}/payment/PayByLink/loadGuestPage?${randomizer}`,
//   payUrl: `${domain}/payment/PayByLink/pay?${randomizer}`,
//   paymentStatusUrl: `${domain}/payment/PayByLink/checkPaymentStatus?${randomizer}`,
//   tocUrl: `${domain}/payment/PayByLink/terms?${randomizer}`,
// });

const getApiPath = () => ({
  localizationUrl: `/payment/PayByLink/labels?${randomizer}`,
  gatewayConfigUrl: `/payment/PayByLink/getBillingDetails?${randomizer}`,
  dataUrl: `/payment/PayByLink/loadGuestPage?${randomizer}`,
  payUrl: `/payment/PayByLink/pay?${randomizer}`,
  payUrl_v2: `/payment/PayByLink/v2/pay?${randomizer}`,
  paymentStatusUrl: `/payment/PayByLink/checkPaymentStatus?${randomizer}`,
  tocUrl: `/payment/PayByLink/terms?${randomizer}`,
});

type TEnv = {
  mappingServiceUrl: string;
  apiDomain: string;
  useDummyData?: boolean;
  publishableKey?: string;
  paymentReturnUrl?: string;
  localizationUrl?: string;
  gatewayConfigUrl?: string;
  dataUrl?: string;
  payUrl?: string;
  paymentStatusUrl?: string;
}

const LocalEnv: TEnv = {
  paymentReturnUrl: '/payment/%1/processing/%2',
  apiDomain: 'https://hotels.cloudbeds-dev.com',
  mappingServiceUrl: 'https://api.cloudbeds-dev.com/mapping/v1.0/mfd/property?hash=',
};

const DevEnv: TEnv = {
  ...LocalEnv,
  apiDomain: 'https://hotels.cloudbeds-dev.com',
  mappingServiceUrl: 'https://api.cloudbeds-dev.com/mapping/v1.0/mfd/property?hash=',
};

const StageEnv: TEnv = {
  ...LocalEnv,
  apiDomain: `https://hotels.cloudbeds-stage.com`,
  mappingServiceUrl: 'https://api.cloudbeds-stage.com/mapping/v1.0/mfd/property?hash=',
};

const ProdEnv: TEnv = {
  ...LocalEnv,
  apiDomain: `https://hotels.cloudbeds.com/`,
  mappingServiceUrl: 'https://api.cloudbeds.com/mapping/v1.0/mfd/property?hash=',
};

const Envs = {
  local: LocalEnv,
  dev: DevEnv,
  stage: StageEnv,
  prod: ProdEnv,
};


const currentEnv = getEnv();
// const domain = sessionStorage.getItem('API_DOMAIN') || Envs[currentEnv].apiDomain;

const AppConfig = {
  ...Envs[currentEnv],
  // ...getApiPath(domain),
  ...getApiPath(),
};

export { AppConfig };
